import React from 'react';
import { useParams } from 'react-router-dom';
import Menu from './components/Menu';
import Calendar from './components/planning/Calendar';
import PlanForm from './components/planning/PlanForm';

import './css/App.css';

const Plan = () => {
    const { personId } = useParams(); // Access the route parameter

    return (
        <div className="App">
            <Menu />
            <Calendar />
            {/* {personId ? <PlanForm personId={personId} /> : null} */}
        </div>
    );
};

export default Plan;